// @ts-ignore
import blackCursor from "../images/blackCursor32.png"
// @ts-ignore
import whiteCursor from "../images/whiteCursor32.png"
// @ts-ignore
import blackHand from "../images/blackHand32.png"
// @ts-ignore
import whiteHand from "../images/whiteHand32.png"
import { ThemeMode } from "../types"
import Brightness5TwoToneIcon from '@mui/icons-material/Brightness5TwoTone'
import DarkModeTwoToneIcon from '@mui/icons-material/DarkModeTwoTone'

const lightSepia = "#F4ECD8"

export const getTheme = (mode: ThemeMode) => {

    const transitions = {
        scrollbarColor: "scrollbar-color 100ms ease",
        backgroundColor: "background-color 500ms ease",
        color: "color 500ms ease",
        border: "border 500ms ease"
    }

    switch(mode) {
        case "dark":
            return {
                font: "'JetBrains Mono Variable', monospace",
                background: "black",
                sky: "rgb(39 17 61)",
                text: {
                    primary: "white",
                    contrast1: "#FF822E",
                    contrast2: "#FFFF00",
                    contrast3: "#59FF00",
                    contrast4: "#00FFFF",
                    contrast5: "#ED63F0"
                },
                cursor: {
                    default: whiteCursor,
                    pointer: whiteHand
                },
                misc: {
                    buttonHover: "rgba(255,255,255,0.25)"
                },
                icons: {
                    cicada: "/icons/icon-72x72-light.png",
                    switchMode: Brightness5TwoToneIcon
                },
                transitions
            }
        case "light":
            return {
                font: "'JetBrains Mono Variable', monospace",
                background: lightSepia,
                sky: "rgb(241 225 177)",
                text: {
                    primary: "black",
                    contrast1: "#B50000",
                    contrast2: "#7B04DD",
                    contrast3: "#0A7600",
                    contrast4: "#0835FF",
                    contrast5: "#AE018E"
                },
                cursor: {
                    default: blackCursor,
                    pointer: blackHand
                    
                },
                misc: {
                    buttonHover: "rgba(0,0,0,0.05)" 
                },
                icons: {
                    cicada: "/icons/icon-72x72.png",
                    switchMode: DarkModeTwoToneIcon
                },
                transitions
            }
    }
};